export default "__VITE_ASSET__B0HAEp1y__"